import React from 'react';
import appConfig from 'app-config';
import { useModal } from '@jutro/components';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { MLModalService } from 'ml-portals-services-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';

import  { MLPartnerCarrierPopup, MLPartnerCarrierPopupMsg } from 'gw-capability-gateway-react';

let GafSubmissionVM;

function MLAgentChoiceReportService() {
    const modalApi = useModal();
    const { authHeader } = useAuthentication();

    const {
        showProgressDialog,
    } = MLModalService();

    const _isInGPA = () => {
        return appConfig.portalCode === 'GPA';
    };

    const _showModal = (quoteID) => {
        const componentProps = {
            title: MLPartnerCarrierPopupMsg.partnerCarriers,
            overrideProps: {
                jobNumber: quoteID
            },
            CustomComponent: MLPartnerCarrierPopup,
            additionalPEStyle: 'customFooterModal'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const setSubmissionVMForGAF = (submissionVM) => {
        GafSubmissionVM = submissionVM;
    };

    const showReportModalWithQuoteID = (quoteID) => {
        if (_isInGPA()) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (user.isChoiceAgent_ML) {
                    _showModal(quoteID);
                }
            });
        }
    };

    const showReportModalWithSubmissionVM = (submissionVM) => {
        if (_isInGPA()) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (user.isChoiceAgent_ML && submissionVM.isChoiceAgentSubmission_ML.value) {
                    _showModal(submissionVM.quoteID.value);
                }
            });
        }
    };

    const _setChoiceAgentPromise = (additionalHeaders) => {
        const setChoiceAgentSubPromise = LoadSaveService.setChoiceAgentSubmission(GafSubmissionVM.value, additionalHeaders);
        showProgressDialog(platformMessages.syncAgentChoice, setChoiceAgentSubPromise);
        setChoiceAgentSubPromise.then((sub) => {
            GafSubmissionVM.isChoiceAgentSubmission_ML.value = sub.isChoiceAgentSubmission_ML;
            GafSubmissionVM = null;
        });
    };

    return {
        saveReport(jobNumber, choiceReportingDTOMLs, additionalHeaders) {
            if (GafSubmissionVM && !GafSubmissionVM.isChoiceAgentSubmission_ML.value) {
                _setChoiceAgentPromise(additionalHeaders);
            }
            return JsonRPCService.send(getProxiedServiceUrl('choicereport'),
                'saveReport',
                [jobNumber, choiceReportingDTOMLs],
                additionalHeaders);
        },
        loadReport(jobNumber, additionalHeaders) {
            return JsonRPCService.send(getProxiedServiceUrl('choicereport'),
                'loadReport',
                [jobNumber],
                additionalHeaders);
        },
         saveBindableChoiceReport(choiceReportDTO, additionalHeaders) {
            return JsonRPCService.send(getProxiedServiceUrl('choicereport'),
                'saveBindableChoiceReport',
                [choiceReportDTO],
                additionalHeaders);
        },
        showReportModalWithQuoteID,
        showReportModalWithSubmissionVM,
        setSubmissionVMForGAF
    };
}

export default MLAgentChoiceReportService;
